export const OPTHINES = {
  voteName: '2020project/2020writing',
  mustSearch: 'Button',
  buttonBg: 'rgb(201, 149, 100)',
  number: {
    mustRank: false,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
  themeColor: {
    activeBgColor: 'rgb(201, 150, 100)',
    inactiveBgColor: 'rgb(244, 179, 112)',
  },
  tabs: [
    {
      tabName: '活动首页',
      tabPath: '/20190121MSMZWriting/First',
    },
    {
      tabName: '我要投稿',
      tabPath: '/20190121MSMZWriting/Uploading',
    },
    {
      tabName: '活动规则',
      tabPath: '/20190121MSMZWriting/Rules',
    },
  ],
};
